import { render, staticRenderFns } from "./vFoPWarning.vue?vue&type=template&id=5dc53bdb&scoped=true"
import script from "./vFoPWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./vFoPWarning.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc53bdb",
  null
  
)

export default component.exports